import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';

const SwitcherContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const LanguageButton = styled.button<{ $active: boolean }>`
  background: transparent;
  border: none;
  font-size: 0.9rem;
  font-weight: ${({ $active }) => ($active ? '700' : '400')};
  color: ${({ $active }) => ($active ? 'var(--accent-primary)' : 'var(--text-primary)')};
  cursor: pointer;
  text-transform: uppercase;
  padding: 0.3rem 0.5rem;
  border-radius: 2px;
  transition: all 0.2s ease;
  
  &:hover {
    color: var(--accent-primary);
  }
`;

const Divider = styled.span`
  color: var(--text-secondary);
  font-size: 0.9rem;
`;

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <SwitcherContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      <LanguageButton 
        $active={language === 'it'} 
        onClick={() => setLanguage('it')}
        aria-label="Cambia lingua a italiano"
      >
        IT
      </LanguageButton>
      <Divider>|</Divider>
      <LanguageButton 
        $active={language === 'en'} 
        onClick={() => setLanguage('en')}
        aria-label="Switch language to English"
      >
        EN
      </LanguageButton>
    </SwitcherContainer>
  );
};

export default LanguageSwitcher; 